// extracted by mini-css-extract-plugin
module.exports = {"root":"whatYouGet_root__3RZz2","tight":"whatYouGet_tight__3CcpG","rootInverted":"whatYouGet_rootInverted__14UjP"};